<template>
  <div style="width: 100%; height: 100%; display: flex; flex-direction: column">
    <header>
      <h2>{{ $t('YSB.title') }}</h2>
      <a-form-model class="searchForm" layout="inline" style="flex: 1; padding: 0 20px; display: flex; justify-content: center;">
        <a-form-model-item label="ID" style="width: 30%">
          <a-input style="width: 100%" v-model="query.id" @keyup.enter="handleSearch" />
        </a-form-model-item>
        <a-form-model-item :label="$t('YSB.name')" style="width: 30%">
          <a-input style="width: 100%" v-model="query.name" @keyup.enter="handleSearch" />
        </a-form-model-item>
        <a-form-model-item :label="$t('YSB.mobile')" style="width: 30%">
          <a-input style="width: 100%" v-model="query.mobile" @keyup.enter="handleSearch" />
        </a-form-model-item>
      </a-form-model>
      <a-space>
        <a-button v-show="buttonsShow['payment:ysb:staff:query']" type="primary" @click="handleSearch">{{ $t('buttons.search') }}</a-button>
        <a-button v-show="buttonsShow['payment:ysb:staff:insert']" type="primary" @click="showStaffModalAsAdd">{{ $t('buttons.add') }}</a-button>
      </a-space>
    </header>
    <div class="YSBStaff" v-loading="isLoading">
      <div v-for="s in staffs" :key="s.id" class="d_cardInsideBox" style="width: 18%; height: 130px;">
        <div class="d_topWrapBox">
          <div class="topMenuBox">
            <div class="menuTitle">
              {{ s.name }}
              <label
                class="ant-checkbox-wrapper"
                style="display: none;"
              >
                <span class="ant-checkbox">
                  <input type="checkbox" class="ant-checkbox-input" value />
                  <span class="ant-checkbox-inner"></span>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="contentBox">
          <p class="id">ID: {{ s.id }}</p>
          <p class="mobile">{{ $t('YSB.mobile') }}: {{ s.mobile }}</p>
          <div class="btn">
            <a-button v-show="buttonsShow['payment:ysb:staff:update']" type="link" @click="showStaffModalAsEdit(s)">{{ $t('buttons.edit') }}</a-button>
            <a-popconfirm
              :key="lang"
              :title="$t('messages.ctrd')"
              :ok-text="$t('common.okText')"
              :cancel-text="$t('common.cancelText')"
              @confirm="removeStaff(s)"
            >
              <a-button v-show="buttonsShow['payment:ysb:staff:delete']" :loading="s.isRemoving" type="link" style="color: #ff4d4f; margin-left: 10px">{{ $t('buttons.delete') }}</a-button>
            </a-popconfirm>
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1; display: flex; justify-content: flex-end; align-items: end; padding-right: 20px; padding-bottom: 15px">
      <a-pagination show-quick-jumper hideOnSinglePage :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total" @change="handlePageChange" />
    </div>
    <a-modal v-model="isModalVisible" :title="title" :confirmLoading="isSubmitting" :afterClose="clearForm" @ok="save" :width="650">
      <a-form-model style="width: 100%;" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" :rules="rules" :model="form" ref="form">
        <a-form-model-item label="ID" prop="id">
          <a-input :disabled="title === $t('YSB.editTitle')" v-model="form.id" />
        </a-form-model-item>
        <a-form-model-item :label="$t('YSB.name')" prop="name">
          <a-select
            v-model="form.name"
            show-search
            option-label-prop="label"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="fetching ? undefined : null"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            @inputKeydown.enter="searchUsers($event, 'realName')"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option @click.native="selectUser(u)" v-for="(u, i) in users" :key="u.id" :value="u.realName + ' ' + i" :label="u.realName">
              {{ u.realName }} - {{ u.username }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('YSB.mobile')" prop="mobile">
          <a-select
            v-model="form.mobile"
            show-search
            option-label-prop="label"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="fetching ? undefined : null"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            @inputKeydown.enter="searchUsers($event, 'username')"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option @click.native="selectUser(u)" v-for="u in users" :key="u.id" :value="u.username" :label="u.username">
              {{ u.realName }} - {{ u.username }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('YSB.JDOrganization')" style="position: relative" prop="fOrgId">
          <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="form.fOrgId" @change="getJDYDepartments">
            <a-select-option @click.native="setFOrgName(o)" v-for="o in JDYOrganizations" :key="o.fid">
              {{ o.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('YSB.JDDepartment')" style="position: relative" prop="fDeptId">
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            v-model="form.fDeptId"
            :show-search="!!form.fOrgId"
            @inputKeydown.enter="searchDept"
          >
            <a-select-option @click.native="setFDeptName(o)" v-for="o in JDYDepartments_searchResult" :key="o.fid">
              {{ o.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  searchYSBStaffs,
  postYSBStaff,
  putYSBStaff,
  deleteYSBStaff
} from '@/api/YSB'
import { getJDYOrganizations, getJDYDepartments } from '@/api/JDY'
import { searchUserList } from '@/api/auth/user'

export default {
  data() {
    return { 
      staffs: [],
      isLoading: false,
      pagination: {
        current: 1,
        pageSize: 25,
        total: 0
      },
      query: {
        id: '',
        name: '',
        mobile: ''
      },
      isModalVisible: false,
      title: '',
      form: {
        id: '',
        name: '',
        mobile: '',
        fOrgId: undefined,
        fOrgName: '',
        fDeptId: undefined,
        fDeptName: ''
      },
      isSubmitting: false,
      rules: {
        id: [
          {
            required: true,
            message: this.$t('messages.YSBID'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.YSBName'),
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: this.$t('placeholder.mobile'),
            trigger: 'blur'
          }
        ],
        fOrgId: [
          {
            required: true,
            message: this.$t('messages.JDO')
          }
        ],
        fDeptId: [
          {
            required: true,
            message: this.$t('messages.JDD')
          }
        ]
      },
      buttonsShow: {
        'payment:ysb:staff:query': false,
        "payment:ysb:staff:insert": false,
        "payment:ysb:staff:update": false,
        "payment:ysb:staff:delete": false
      },
      JDYOrganizations: [],
      JDYDepartments_searchResult: [],
      fetching: false,
      users: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    this.translate()
    this.queryParams = {
      query: [
        {
          field: 'name',
          value: ''
        },
        {
          field: 'id',
          value: ''
        },
        {
          field: 'mobile',
          value: ''
        }
      ],
      sort: [],
      filter: []
    }
    const a = this.getAuthorities('/YSBStaff')
    a.forEach(aa => this.buttonsShow[aa.code] = true)
    this.getStatffs()
    this.getJDYOrganizations()
  },
  methods: {
    translate() {
      this.rules = {
        id: [
          {
            required: true,
            message: this.$t('messages.YSBID'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.YSBName'),
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: this.$t('placeholder.mobile'),
            trigger: 'blur'
          }
        ],
        fOrgId: [
          {
            required: true,
            message: this.$t('messages.JDO')
          }
        ],
        fDeptId: [
          {
            required: true,
            message: this.$t('messages.JDD')
          }
        ]
      }
    },
    async getStatffs() {
      this.isLoading = true
      try {
        const { data } = await searchYSBStaffs(this.pagination.current, this.pagination.pageSize, this.queryParams)
        this.staffs = data.records
        this.pagination.total = data.total
        this.pages = data.pages
      } catch(e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange(p) {
      this.pagination.current = p
      this.getStatffs()
    },
    handleSearch() {
      this.pagination.current = 1
      this.queryParams.query = []
      for (let k in this.query) {
        this.queryParams.query.push({
          field: k,
          value: this.query[k]
        })
      }
      this.getStatffs()
    },
    showStaffModalAsAdd() {
      this.isModalVisible = true
      this.title = this.$t('YSB.addTitle')
    },
    showStaffModalAsEdit(s) {
      this.isModalVisible = true
      this.title = this.$t('YSB.editTitle')
      this.form = {...s}
      if (this.form.fOrgId) {
        this.getJDYDepartments()
      }
    },
    clearForm() {
      this.form = {
        id: '',
        name: '',
        mobile: ''
      }
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          const form = {
            ...this.form,
            name: this.form.name.split(' ')[0]
          }
          try {
            if (this.title === this.$t('YSB.editTitle')) {
              const { message } = await putYSBStaff(form)
              this.$message.success(message)
            }
            if (this.title === this.$t('YSB.addTitle')) {
              const { message } = await postYSBStaff(form)
              if (this.pages * this.pagination.pageSize === +this.pagination.total) {
                this.pagination.current = this.pages + 1
              } else {
                this.pagination.current = this.pages
              }
              this.$message.success(message)
            }
            this.isModalVisible = false
            this.clearForm()
            this.getStatffs()
          } catch(e) {
            console.log(e)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },
    async removeStaff(s) {
      s.isRemoving = true
      this.$forceUpdate()
      try {
        const { message } = await deleteYSBStaff(s.id)
        if (this.staffs.length === 1 && this.pagination.current > 1) {
          this.pagination.current--
        }
        this.getStatffs()
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      } finally {
        s.isRemoving = false
        this.$forceUpdate()
      }
    },
    async getJDYDepartments() {
      try {
        const { data } = await getJDYDepartments({ orgId: this.form.fOrgId })
        this.JDYDepartments_searchResult = this.JDYDepartments = data
      } catch(e) {
        console.log(e)
      }
    },
    setFOrgName(o) {
      this.form.fOrgName = o.name
    },
    async getJDYOrganizations() {
      try {
        const { data } = await getJDYOrganizations()
        this.JDYOrganizations = data
      } catch(e) {
        console.log(e)
      }
    },
    searchDept(e) {
      const value = e.target.value = e.target.value?.trim() || ''

      this.JDYDepartments_searchResult = []
      let d
      for (let i = 0; i < this.JDYDepartments.length; i++) {
        d = this.JDYDepartments[i]
        if (d.name.includes(value)) {
          this.JDYDepartments_searchResult.push(d)
        }
      }
    },
    setFDeptName(o) {
      this.form.fDeptName = o.name
    },
    async searchUsers(e, field) {
      this.users = []
      this.fetching = true
      try {
        const { data } = await searchUserList(1, 100, {
          query: [
            {
              field,
              value: e.target.value.trim()
            }
          ],
          filter: [],
          sort: []
        })
        this.users = data.records
      } catch(e) {
        console.log(e)
      } finally {
        this.fetching = false
      }
    },
    selectUser(u) {
      this.form.name = u.realName
      this.form.mobile = u.username
    }
  }
}
</script>

<style lang="less" scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 35px 0 30px;
  h2 {
    margin: 0;
    padding: 0;
  }
}
.YSBStaff {
  display: flex;
  flex-wrap: wrap;
  padding-left: 15px;
}
.d_cardBorderBox {  
  display: flex;
  justify-content: center;
  align-items: center;
}
.d_cardInsideBox {
  border-radius: 5px;
  box-shadow: 0 0 5px #cacaca;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 15px;
  margin-bottom: 5px;
}
.d_topWrapBox {
  border-bottom: 1px solid #e0e0e0;
}
.contentBox{
  width: 100%;
  height: 90%;
  background-color: white;
  padding: 10px 15px;
  box-sizing: border-box;
  position: relative;
  .btn {
    position: absolute;
    right: 10px;
    bottom: 0;
    /deep/ .ant-btn-link {
      margin: 0;
      padding: 0;
    }
  }
}
.topMenuBox {
  background-color: rgb(114, 157, 177);
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
  padding: 0 15px;
}
.searchForm /deep/ .ant-form-item-control-wrapper {
  width: 80%;
}
</style>